import { ConfigResponse } from '../apiResponseTypes';

export const TRY_GET_APP_CONFIG = 'TRY_UPDATE_APP_CONFIG';
export const TRY_SILENT_GET_APP_CONFIG = 'TRY_SILENT_GET_APP_CONFIG';
export const GET_APP_CONFIG_SUCCESS = 'UPDATE_APP_CONFIG_SUCCESS';

export interface TryUpdateAppConfigAction {
    type: typeof TRY_GET_APP_CONFIG;
}

export interface TrySilentUpdateAppConfigAction {
    type: typeof TRY_SILENT_GET_APP_CONFIG;
}

export interface GetAppConfigSuccessAction {
    type: typeof GET_APP_CONFIG_SUCCESS;
    payload: ConfigResponse;
}

// Action creators

export const trySilentGetAppConfig: () => TrySilentUpdateAppConfigAction = () => {
    return {
        type: TRY_SILENT_GET_APP_CONFIG,
    };
};

export const tryGetAppConfig: () => TryUpdateAppConfigAction = () => {
    return {
        type: TRY_GET_APP_CONFIG,
    };
};

export const getAppConfigSuccess: (payload: ConfigResponse) => GetAppConfigSuccessAction = (payload) => {
    return {
        type: GET_APP_CONFIG_SUCCESS,
        payload,
    };
};
